module.exports = __webpack_public_path__ + "img/circle-dots.d94b85d1.svg";